import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row, Table } from 'react-bootstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ring2, dotWave } from 'ldrs';
import { CgMenuBoxed } from "react-icons/cg";
import { RiDeleteBin6Line } from "react-icons/ri";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../SACss.css";
import Cookies from 'js-cookie';
import { decryptData } from "../../../Auth/cryptage";



function ModelsSA() {
    const MySwal = withReactContent(Swal);
    const [models, setModels] = useState([]);
    const [filteredModels, setFilteredModels] = useState([]);
    const [loading, setLoading] = useState({
        who: '',
        status: false,
        userId: null
    });

    dotWave.register();
    ring2.register();
    useEffect(() => {
        AOS.init({ duration: 1200 });
        getModels();
    }, []);
    useEffect(() => {
        document.title = "GecimmoIA - Models";
    }, []);
    const getModels = async () => {
        try {
            setLoading({ who: 'modele', status: true, userId: null });
            const token = decryptData(Cookies.get('access_token'));
            // console.log()(token);
            const result = await axios.get('https://api.ai.easysystem.cloud/api/super-admin/modeles', {
                headers: {
                    'X-Custom-Token': token
                }
            });
            // // console.log()(result.data.modeles);
            setModels(result.data.modeles);
            setFilteredModels(result.data.modeles);
        } catch (error) {
            console.error("Error fetching questions: ", error);
            setModels([]); 
        } finally {
            setLoading({ 
                who: 'modele', 
                status: false, 
                userId: null 
            });
        }
    };
    const Search = (searchTerm) => {
        const lowercased = searchTerm.toLowerCase();
        const filteredData = models.filter((model) =>
            Object.keys(model).some((key) => {
                const value = model[key];
                if (Array.isArray(value)) {
                    return value.some(item => 
                        Object.values(item).some(val => String(val).toLowerCase().includes(lowercased))
                    );
                }
                return String(value).toLowerCase().includes(lowercased);
            })
        );
    
        setFilteredModels(filteredData);
    };
    
    const isArrayEmpty = (arr) => !Array.isArray(arr) || arr.length === 0;
    const deleteModel = async (id) => {
        try {
            const result = await MySwal.fire({
                title: "Êtes-vous sûr ?",
                text: "Vous ne pourrez pas annuler cela !",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Oui, supprimez-le !",
                cancelButtonText: "Annuler"
            });
    
            if (result.isConfirmed) {
                setLoading({ who: 'delete', status: true, userId: id });
                const token = decryptData(Cookies.get('access_token'));
                await axios.delete(`https://api.ai.easysystem.cloud/api/super-admin/model/delete/${id}`, {
                    headers: { 'X-Custom-Token': token }
                });
                MySwal.fire({ 
                    title: "Deleted!", 
                    text: "Model has been deleted", 
                    icon: "success" 
                });
                getModels();
            }
        } catch (err) {
            MySwal.fire({ 
                title: "Error!", 
                text: err.message, 
                icon: "error" 
            });
        } finally {
            setLoading({ 
                who: 'delete', 
                status: false, 
                userId: null 
            });
        }
    };
    

    return (
        <Container>

            <Row data-aos="fade-left" className='my-4'>
                <Col>
                    <h1><CgMenuBoxed className='mb-2 mx-2' /> Models</h1>
                </Col>
                
            </Row>
            <Row>
                <Col className='d-flex justify-content-end'>
                    <div className="containerSearch">
                        <input className="checkboxSearch" type="checkbox" />
                        <div className="mainboxSearch">
                            <div className="iconContainerSearch">
                                <svg
                                    viewBox="0 0 512 512"
                                    height="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="search_icon mb-1"
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                                </svg>
                            </div>
                            <input
                                className="search_input"
                                placeholder="Recherche"
                                type="text"
                                onChange={(e) => Search(e.target.value)}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Table striped bordered hover responsive className="text-center align-middle custom-table">
                    <thead data-aos="fade-down" className="thead-dark">
                        <tr>
                            <th>#Id</th>
                            <th>Question</th>
                            <th>Type</th>
                            {/* <th>Modele</th> */}
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody data-aos="fade-up">
                        {
                            loading.status && loading.who === "modele" ?
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        <l-dot-wave size="47" speed="1" color="black"></l-dot-wave>
                                    </td>
                                </tr>
                                :isArrayEmpty(filteredModels) ? (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            Not Found
                                        </td>
                                    </tr>
                                    ) : models.length === 0 ?
                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            No models found.
                                        </td>
                                    </tr>
                                    : filteredModels.map((model) => (
                                        <tr key={model.id} className='text-center'>
                                            <td>{model.id}</td>
                                            <td>{model.content}</td>
                                            {/* <td>{model.typeQ}</td> */}
                                            <td>{model.typeQ}</td>
                                            <td className='d-flex justify-content-around'>
                                                <Button className='btn btn-danger' onClick={() => deleteModel(model.id)}>
                                                    {
                                                        loading.status && loading.who === "delete" && loading.userId === model.id ?
                                                            <l-ring-2
                                                                size="25"
                                                                stroke="3"
                                                                stroke-length="0.25"
                                                                bg-opacity="0.1"
                                                                speed="0.8"
                                                                color="white"
                                                            ></l-ring-2>
                                                            : <RiDeleteBin6Line className='mx-2' />
                                                    }
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                        }
                    </tbody>
                </Table>
            </Row>
        </Container>
    );
}

export default ModelsSA;
